<style lang="stylus">
    .mo-userworks
        .user-frame
            width 100%
            height 100%
        .ivu-tabs-tabpane,.ivu-scroll-wrapper,.ivu-scroll-container
            height 100% !important;
        .ivu-scroll-container
            overflow-y auto
        .ivu-tabs-tab
            &:hover
                color var(--themeColor)!important

        .ivu-modal
            width 100% !important
            height 100%
        .ivu-modal-content
            border-radius 0
        // .ivu-modal-close
        //     z-index 9999

        //     i
        //         display block
        //         font-size 40px

        .ivu-modal-body
            height 580px
            padding 0 24px
            padding-bottom 60px
            overflow auto
            background #f8f9fa
            border-radius 6px

        .mo-userworks--userinfo
            margin-bottom 20px
            position absolute
            top 0
            left 0
            right 8px
            padding 30px 70px 10px 70px
            z-index 9
            background white
            border-radius $border-radius-base
            flex-wrap nowrap

            div
                position relative

                .vip-icon
                    position absolute
                    bottom 0
                    left 55px

        .mo-userworks--avatar
            display block
            width 70px
            height 70px
            border-radius 50%
            margin-right 35px

        .mo-userworks--name
            font-size 26px
            color black
            vertical-align top

        .mo-userworks--profile
            font-size 15px
            color $text-color
            vertical-align bottom
            max-height 40px
            max-width 850px
            overflow hidden
            text-overflow ellipsis
            white-space nowrap

        .mo-userworks--edit
            position absolute
            right 70px
            top 35px
            z-index 2
            cursor pointer

            svg
                width 25px
                height 25px
                transition fill $transition-time $ease-in-out

                &:hover
                    fill var(--themeColor)

        .mo-userworks--follow
            width auto
            height auto

        .mo-userworks--user
            height 40px
            float left
            display flex
            align-items center
            margin 20px 20px 0 20px
            cursor pointer
            transition transform $transition-time $ease-in-out

            &:hover
                transform scale(1.1)

            img, svg
                width 35px
                height 35px
                border-radius 50%
                margin-right 15px

            span
                font-size 14px
                color $text-color-dark
                max-width 130px
                overflow hidden
                text-overflow ellipsis
                white-space nowrap

        .mo-userworks--hint
            text-align center
            padding-top 40px
            font-size 14px
            color $text-color-light

        .ivu-tabs
            margin-top 90px
            height calc(100% - 90px)

            .ivu-tabs-content
                height calc(100% - 52px)
                overflow-y auto

        .mo-waterfall
            //margin 165px 0 0 0
            padding-right 6px
            margin-right 8px

        .mo-waterfall--grid-sizer
            width 18.18%

        .mo-work
            width 18.18%

        .mo-waterfall--gutter-sizer
            width 2.27%

        .sc-load-spin
            margin-left 0


    @media screen and (max-height: 900px)
        .mo-userworks
            .ivu-modal
                padding 50px 0

            .ivu-modal-content
                height 100%

    //个人作品瀑布流宽度的自适应
    @media screen and (max-width: 1210.625px)
        .mo-userworks
            .mo-waterfall--grid-sizer
                width 22.86%

            .mo-work
                width 22.86%

            .mo-waterfall--gutter-sizer
                width 2.86%

    @media screen and (max-width: 968.75px)
        .mo-userworks
            .mo-waterfall--grid-sizer
                width 30.769999999999996%

            .mo-work
                width 30.769999999999996%

            .mo-waterfall--gutter-sizer
                width 3.85%

    @media screen and (max-width: 726.875px)
        .mo-userworks
            .mo-waterfall--grid-sizer
                width 47.06%

            .mo-work
                width 47.06%

            .mo-waterfall--gutter-sizer
                width 5.88%

    @media screen and (max-width: 485px)
        .mo-userworks
            .mo-waterfall--grid-sizer
                width 100%

            .mo-work
                width 100%

            .mo-waterfall--gutter-sizer
                width 12.5%

    .mo-userworks--interests
        display flex
        flex-wrap wrap

    .mo-userworks--interest
        padding 5px 10px
        background #FFFFFF
        box-shadow 0 0 4px 0 rgba(0, 0, 0, 0.1)
        box-sizing border-box
        margin-bottom 10px
        margin-right 20px

        .Icon
            width 15px
            height 15px
            margin-left 3px
            position relative
            transition all $transition-time $ease-in-out
            cursor pointer
            position relative
            top -4px
            left -4px

            &:hover
                color red

    .tpl-loading
        position absolute
        left 0
        right 0
        top 150px
        bottom 0
        background #fff
        display flex
        justify-content center
        align-items center
        z-index 10
        pointer-events none

        img
            width 300px
</style>

<template>
    <div>
        <User v-if="showUserWorks" />
    </div>
</template>

<i18n>
{
  "zh": {
    "works": "作品",
    "following": "关注",
    "fans": "粉丝",
    "follow": "关注",
    "unFollow": "取消关注",
    "actionSuccess": "操作成功！",
    "theEnd": "到底了",
    "noneWork": "暂无相关作品",
    "noFocus": "暂无关注",
    "noFans": "暂无粉丝"
  },
  "en": {
    "works": "Works",
    "following": "Following",
    "fans": "Followers",
    "follow": "Follow",
    "unFollow": "Unfollow",
    "actionSuccess": "Successful operation!",
    "theEnd": "Bottom",
    "noneWork": "No works yet",
    "noFocus": "No following",
    "noFans": "No followers yet"
  },
  "de": {
    "works": "Werkzeug",
    "following": "Folgen",
    "fans": "Fans",
    "follow": "Befolgen ",
    "unFollow": "Befolgen ausfallen",
    "actionSuccess": "Operation erfolgreich! ",
    "theEnd": "Zum Ende",
    "noneWork": "Keine verwandten Werkzeuge",
    "noFocus": "Keine Ansichten",
    "noFans": "Keine Fans"
  },
  "fr": {
    "works": "Travaux",
    "following": "Suivant",
    "fans": "Abonnés",
    "follow": "Suivre",
    "unFollow": "Se désabonner",
    "actionSuccess": "Opération réussie!",
    "theEnd": "À la fin",
    "noneWork": "Pas de travaux connexes",
    "noFocus": "Pas d'attention",
    "noFans": "Pas de fans"
  },
  "es": {
    "works": "Obras",
    "following": "Siguiendo",
    "fans": "Seguidores",
    "follow": "Seguir",
    "unFollow": "Dejar de seguir",
    "actionSuccess": "¡Operación exitosa!",
    "theEnd": "Fondo",
    "noneWork": "Aún no funciona",
    "noFocus": "No hay seguidores",
    "noFans": "Sin seguidores todavía"
  },
  "jp": {
    "works": "作品",
    "following": "フォロー",
    "fans": "フォロワー数",
    "follow": "フォロー",
    "unFollow": "フォロー解除",
    "actionSuccess": "操作成功！",
    "theEnd": "最後です",
    "noneWork": "関連作品はありません",
    "noFocus": "フォローがありません",
    "noFans": "フォロワー数がありません"
  },
  "pt": {
    "works": "obras",
    "following": "Seguido",
    "fans": "Seguidores",
    "follow": "Seguir",
    "unFollow": "Deixar de seguir",
    "actionSuccess": "Operação com sucessso!",
    "theEnd": "No final",
    "noneWork": "Ainda não há obras",
    "noFocus": "Sem seguir",
    "noFans": "Ainda sem seguidores"
  },
  "it": {
    "works": "Lavori",
    "following": "Seguenti",
    "fans": "Seguaci",
    "follow": "Seguire",
    "unFollow": "Annulla l'iscrizione",
    "actionSuccess": "Operazione riuscita!",
    "theEnd": "Alla fine",
    "noneWork": "Nessun lavoro correlato",
    "noFocus": "Nessuna attenzione",
    "noFans": "Nessun fan"
  },
  "tw": {
    "works": "作品",
    "following": "關注",
    "fans": "粉絲",
    "follow": "關注",
    "unFollow": "取消關注",
    "actionSuccess": "操作成功！",
    "theEnd": "到底了",
    "noneWork": "暫無相關產品",
    "noFocus": "暫無關注",
    "noFans": "暫無粉絲"
  },
  "kr": {
    "works": "작업물",
    "following": "팔로우",
    "fans": "팔로워",
    "follow": "팔로우",
    "unFollow": "팔로우  취소",
    "actionSuccess": "작업 성공!",
    "theEnd": "끝입니다",
    "noneWork": "아직 작업물이 없습니다~",
    "noFocus": "팔로우 없음",
    "noFans": "팔로워 없음"
  },
  "id": {
    "works": "Karya",
    "following": "Mengikuti",
    "fans": "Pengikut",
    "follow": "Ikuti",
    "unFollow": "Berhenti mengikuti",
    "actionSuccess": "Operasi berhasil!",
    "theEnd": "Bawah",
    "noneWork": "Belum ada tugas",
    "noFocus": "Tidak mengikuti",
    "noFans": "Belum ada pengikut"
  }
}
</i18n>

<script lang="ts">
    import "@/home/style/tplLayout.styl";

    import User from "../user/user.vue";
    import { Component, Prop, Vue, Watch, Mixins } from "vue-property-decorator";

    @Component({
        components: {
            User,
        },
    })
    export default class TplUserWorks extends Vue {
        hotTags: Array<any> = [];
        //搜索、排序
        keyword: string = "";
        searchTags: Array<any> = [];
        order: string = "TIME";
        sort: string = "ASC";
        lastSearchWord: string = "";

        //是否显示主题区域的加载动画
        showLoadSpin: boolean = false;
        //是否显示底部loading动画
        showAddSpin: boolean = false;
        //所有作品显示完毕
        allWorkShowed: boolean = false;

        activePane: string = "work";

        //关注的用户和粉丝
        follows: Array<any> = [];
        fans: Array<any> = [];

        inerest: Array<any> = [];

        toScrollWork(e) {
            console.log(e);
        }
        get vipState() {
            return this.$store.state.publicStore.vip;
        }
        get userInfo() {
            return this.$store.state.userInfo;
        }
        get visitUser() {
            return this.$store.state.tplCenter.visitUser;
        }
        get showUserWorks() {
            return this.$store.state.tplCenter.showUserWorks;
        }
        set showUserWorks(val) {
            this.$store.commit("toTplCenter", {
                name: "showUserWorks",
                data: val,
            });
        }
        get selfFollowIds() {
            return this.$store.state.tplCenter.followIds;
        }
        //是否已关注当前用户
        get isFollowed() {
            return (this.selfFollowIds as any).some((item) => {
                if (item == this.visitUser.id) return true;
            });
        }
        get interest() {
            return this.$store.state.tplCenter.interest;
        }
        get hidedInterest() {
            return this.$store.state.tplCenter.hidedInterest;
        }
        get templateLang() {
            return this.$store.state.tplCenter.templateLang;
        }
        toUserCenter() {
            if (this.isPC) {
                (<any>window).$qt.jsCallOpenUserCenter();
            } else {
                window.open(this.urls.accountUrl + `?lang=${this.lang}&tend=max`, "_blank");
            }
        }
        @Watch("showUserWorks")
        trackShow(v) {
            if (v) {
                this.$bus.$emit("closePreview");
                this.sensors.track("userPage", {
                    Catalogues: "Templates",
                    platform: this.isPC ? "desktop" : "online",
                });
            }
        }
        // @Watch("visitUser.id")
        // watchVisitUserID(id) {
        //     let ts: any = this;
        //     if (!id) return;
        //     if(!this.params) return;
        //     let fuser = false;
        //     if (id == this.params.id) {
        //         fuser = this.$store.state.fuser;
        //         //获取自己的兴趣
        //         // this.$store.dispatch("getOwnInterest");
        //     }
        //     this.$store.commit("toVisitUser", {
        //         fuser,
        //         avatar: "",
        //         nickName: "",
        //         profile: ""
        //     });

        //     ts.works = [];
        //     this.activePane = "work";
        //     this.getWorks("search");
        //     this.getRelationships();
        //     this.$edApi
        //         .getUserBasicInfo({ id, token: this.params.token })
        //         .then(data => {
        //             this.$store.commit("toVisitUser", {
        //                 avatar: this.getAvatar(data),
        //                 nickName: data.nick_name,
        //                 profile: data.profile
        //             });
        //         });
        // }
        // @Watch("activePane")
        // watchActivePane(v) {
        //     let ts: any = this;
        //     if(v == 'work'){
        //         this.$nextTick(() => {
        //             this.masnory.layout()
        //         })
        //     }
        //     // WsTrack('Community', "WorkCenter", 'Pane', val);
        //     // ts.$track("Community", "WorkCenter", "Pane");
        // }

        //如果是author电话的话，将电话号码后6位隐藏
        //如果是邮箱的话，隐藏邮箱后缀
        getSafeName(name) {
            if (name.match(/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/)) {
                name = name.substr(0, name.indexOf("@"));
            }
            if (name.match(/^1[3456789]\d{9}$/)) {
                name = name
                    .split("")
                    .map((v, idx) => {
                        if (idx > 4) {
                            return "*";
                        } else {
                            return v;
                        }
                    })
                    .join("");
            }
            return name;
        }
        getAvatar(item) {
            let ava = "";
            let time = Math.round(new Date().getTime() / 1000);
            if (item.avatar) ava = "data:image/png;base64," + item.avatar;
            else if (item.avatar_url) ava = item.avatar_url + `?t=${time}`;
            return ava;
        }
        //type:search/add, way:keyword/undefined
        getWorks(type) {
            let ts: any = this;
            if (!this.visitUser.id) return;
            if (type == "search") {
                //显示主题区域loading动画
                this.showLoadSpin = true;
                this.allWorkShowed = false;
                ts.offset = 0;
                ts.count = 36;
            } else {
                //显示底部loading动画
                this.showAddSpin = true;

                ts.count = 20;
            }
            let params = {
                id: this.visitUser.id,
                offset: ts.offset,
                count: ts.count,
                lang: this.internal ? "zh" : this.templateLang,
                order: "TIME",
                sort: "ASC",
            };
            this.$edApi.getUserWorks(params).then(({ data }) => {
                ts.offset += data.length;
                ts.isAdding = false;
                if (type == "search") {
                    ts.clearWaterfall();

                    this.showLoadSpin = false;

                    if (data.length == 0) {
                        //没有数据说明搜索不到相关内容
                        this.showLoadSpin = false;
                        this.allWorkShowed = true;
                        return;
                    } else if (data.length < 30) {
                        //小于30个说明搜索结果已全部显示
                        this.allWorkShowed = true;
                    }
                } else {
                    //没有数据说明到底了
                    if (data.length == 0) {
                        this.allWorkShowed = true;
                        return;
                    } else if (data.length < 20) {
                        //小于20个说明已全部显示
                        this.allWorkShowed = true;
                    }
                    this.showAddSpin = false;
                }

                ts.updateWaterfall({
                    works: data,
                });
            });
        }
        // getData() {
        //     //获取作品数据
        //     this.getWorks("search");
        //     this.getRelationships();
        // }
        follow() {
            let ts: any = this;
            // WsTrack('Community', "WorkCenter", 'Follow');
            // ts.$track("Community", "WorkCenter", "Follow");
            if (!this.userInfo) return;
            let params = Object.assign({ follow: !this.isFollowed, focus_id: this.visitUser.id }, this.params);
            this.$edApi.follow(params).then(() => {
                this.$edMessage.success(this.$t("actionSuccess"));
                this.getRelationships();
                this.$store.dispatch("getOwnRelationships");
            });
        }
        //获取当前浏览的用户的关注和粉丝
        getRelationships() {
            if (!this.visitUser.id) return;
            this.$edApi.getRelationships({ id: this.visitUser.id }).then((res) => {
                this.follows = res.follow;
                this.fans = res.fans;
            });
        }
        changeVisitedUser(id) {
            this.$store.commit("toVisitUser", {
                id,
            });
        }
        deleteInterest(interestId) {
            let params = {
                id: this.params.id,
                token: this.params.token,
                ids: [interestId],
            };
            this.$edApi.deleteOwnInterest(params).then(() => {
                this.$edMessage.success("成功移除兴趣！");
                this.$store.dispatch("getOwnInterest");
            });
        }
        mounted() {
            this.$bus.$on("closeUserWork", () => {
                this.showUserWorks = false;
            });
        }
        beforeDestroy() {
            this.$bus.$off("closeUserWork");
        }
    }
</script>
